// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { endOfISOWeekYear as fn } from "../endOfISOWeekYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const endOfISOWeekYearWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default endOfISOWeekYearWithOptions;
